import { Alert } from "@evolua/ui";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useOnlineStatus } from "../pwa/use-online-status.js";

const WAKE_HINT_AFTER_MS = 4_000;

/**
 * Mostra aviso quando uma request fica pendente >4s (cold start Render free).
 */
export function ApiWakeBanner() {
  const online = useOnlineStatus();
  const fetching = useIsFetching();
  const mutating = useIsMutating();
  const busy = fetching + mutating > 0;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!online || !busy) {
      setShow(false);
      return;
    }
    const timer = window.setTimeout(() => setShow(true), WAKE_HINT_AFTER_MS);
    return () => window.clearTimeout(timer);
  }, [online, busy]);

  if (!show) return null;

  return (
    <Alert tone="info" className="evolua-api-wake-banner" role="status">
      A API pode estar iniciando (Render free). Isso pode levar cerca de um minuto…
    </Alert>
  );
}
